import { createFileRoute } from "@tanstack/react-router";
//
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
//
import { SpringHealthEligibilityPage } from "@pages/spring-health-eligibility-page";

export const springHealthVerifySchema = z.object({
  spring_id: z.string().catch(""),
  spring_guardian_id: z.string().catch(""),
});

export type SpringHealthVerifySearchSchema = z.infer<
  typeof springHealthVerifySchema
>;

export const Route = createFileRoute("/spring-health/verify")({
  component: SpringHealthEligibilityPage,
  validateSearch: zodValidator(springHealthVerifySchema),
});
